import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
import { MembershipService } from 'src/app/services/membership.service';
import * as moment from "moment";
import { saveAs } from 'file-saver/src/FileSaver';
import { Table } from 'primeng/table';
import { Dropdown } from "primeng/dropdown";
import { LazyLoadEvent } from 'primeng/api';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { CategoryService } from 'src/app/services/category.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface Benefit {
  key: string,
  value: string
}

@Component({
  selector: 'app-academymembership',
  templateUrl: './academymembership.component.html',
  styleUrls: ['./academymembership.component.scss'],
  providers: [MessageService, ConfirmationService]
})

export class AcademymembershipComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public hide: boolean = true;
  productDialog: boolean;
  membershiplist: any;
  submitted: boolean;
  cols: any[];
  staticPath: string;
  totalRecords: 0;
  errorMessage = '';
  loading: boolean;
  adminRoleId;
  calvalue: Date;
  ucalvalue: Date;
  startDate: Date;
  endDate: Date;
  dcalvalue: any;
  scalvalue: any;
  statuses: any[];
  bannerImagePath;
  public bannerImage;
  bannerImage_src;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  displayImages: boolean;
  displayImages1: boolean;
  displayCustom: boolean;
  activeIndex: number = 0;
  public loggedInUser;
  public userId;
  public userRoleId;
  public membershipModule;
  public loggedInUserPermissions;
  public membershipPermissions: any[] = [];
  private lastTableLazyLoadEvent: LazyLoadEvent;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId1", { static: false }) pDropDownId1: Dropdown;
  @ViewChild("pDropDownId2", { static: false }) pDropDownId2: Dropdown;
  @ViewChild("pDropDownId3", { static: false }) pDropDownId3: Dropdown;
  currencyList: any;
  isBenefitsAvailable: boolean = false;
  benefits: Benefit[] = [];
  status: any;
  sportTypeList: any;
  downloadFlg: boolean;
  downloadMembershipList: any;
  paginationOption: (number | { showAll: string; })[];
  membershipTypeList: any;
  searchBy: any[];
  searchby: any;
  sportFilterValue = null;
  constructor(private router: Router, private membershipService: MembershipService, private activatedRoute: ActivatedRoute, private categoryService: CategoryService,
      private messageService: MessageService, private confirmationService: ConfirmationService, private commonService: CommonService,private tokenStorageService: TokenStorageService) { }

  ngOnInit() {
    this.downloadFlg = false;
    this.paginationOption = environment.pagination;
    this.loggedInUser = this.tokenStorageService.getUser();
    this.userId = this.loggedInUser.userdata.id;
    this.userRoleId = this.loggedInUser.userdata.role;

    this.membershipModule = 'Membership';

    this.loggedInUserPermissions = this.tokenStorageService.getUserPermissions();

    this.loggedInUserPermissions.forEach(permission => {
      if (permission.module == this.membershipModule) {
        let permissionObj = {
          moduleName: permission.module,
          status: permission.status,
          permission: permission.permission
        }
        this.membershipPermissions.push(permissionObj);
      }
    });
    if (this.membershipPermissions.length == 0) {
      this.router.navigateByUrl('/manage/dashboard')
    }

    this.membershipTypeList = [
        { label: 'User', value: 'user' },
        { label: 'Academy', value: 'academy' }
    ];

    this.searchBy = [
        { label: 'Created On', value: "created_at" },
        { label: 'Last Modified On', value: "updated_at" }
    ];

    this.statuses = [
        { label: 'Active', value: true },
        { label: 'In-Active', value: false }
    ];
    this.getSportTypeList();
    this.getCurrencyList();
  }

  addNewMembership() {
    this.router.navigate(['/manage/membership/add']);
  }

  editMembership(id) {
    this.router.navigate(['/manage/membership/edit/' + id]);
  }

  getSportTypeList() {
    const query = `?filterByDisable=false&getSubcategory=true&filterByParentCategory=Sport`;
    this.categoryService.getCategoryList(query).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.sportTypeList = [];
      let sportTypeList = data.data.items;
      sportTypeList.forEach(ele => {
        this.sportTypeList.push({ label: ele.name, slug: ele.slug });
      })
    }, err => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.message, life: 6000 });
    })
  }

  getCurrencyList() {
    this.commonService.getCurrencyList().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.currencyList = [];
      let currencyList = data.data.items;
      currencyList.forEach(ele => {
        this.currencyList.push({ label: ele.name, currencySymbol: ele.currency_symbol });
      })
    })
  }

  viewBenefits(benefit) {
    this.isBenefitsAvailable = true;
    this.benefits = benefit;
  }

  loadMemberships(event: LazyLoadEvent) {
      this.lastTableLazyLoadEvent = event;
      var query = "?filterByDisable=false";
      var pagenumber = 1;
      var params = "";
      var rows;
      if (event.first != undefined && event.first == 0) {
          pagenumber = event.first + 1;
      } else if (event.first != undefined && event.first > 0) {
          pagenumber = (event.first / event.rows) + 1;
      } else {
          pagenumber = 1;
      }
      if (event.rows != undefined) {
          rows = event.rows;
      } else {
          rows = 10;
      }
      if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
          params += "&filterByDate=" + this.searchby.value;
          params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
          params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
      }
      if (event.filters != undefined && event.filters["planName"] != undefined) {
          params += "&filterByPlanName=" + event.filters["planName"].value;
      }
      if (event.filters != undefined && event.filters["membershipType"] != undefined) {
          params += "&filterByMembershipType=" + event.filters["membershipType"].value;
      }
      if (event.filters != undefined && event.filters["sport"] != undefined) {
          params += "&filterBySportSlug=" + event.filters["sport"].value.slug;
      }
      if (event.filters != undefined && event.filters["currency"] != undefined) {
          params += "&filterByCurrency=" + event.filters["currency"].value.label;
      }
      if (event.filters != undefined && event.filters["price"] != undefined) {
          params += "&filterByPrice=" + event.filters["price"].value;
      }
      if (event.filters != undefined && event.filters["duration"] != undefined) {
          params += "&filterByDuration=" + event.filters["duration"].value;
      }
      if (event.filters != undefined && event.filters["status"] != undefined) {
          params += "&filterByStatus=" + event.filters["status"].value;
      }
      if (event.filters != undefined && event.filters["createdby"] != undefined) {
          params += "&filterByCreatedby=" + event.filters["createdby"].value;
      }
      if (event.filters != undefined && event.filters["updatedby"] != undefined) {
          params += "&filterByUpdatedby=" + event.filters["updatedby"].value;
      }
      // at the time of download hide pagination option
      if (this.downloadFlg == false) {
          if (params != undefined && params != "") {
              query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
          } else {
              query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
          }
      } else {
          if (params != undefined && params != "") {
              query += params;
          }
      }
      if (event.sortField != undefined && event.sortOrder != undefined) {
          var orderBy = "";
          if (event.sortOrder == 1) {
              orderBy = "DESC";
          } else {
              orderBy = "ASC";
          }
          query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
      }

      this.membershipService.getAllMembership(query).pipe(takeUntil(this.destroy$)).subscribe(
          (data: any) => {
              if (this.downloadFlg === true) {
                  this.downloadFlg = false;
                  this.exportExcelSheet(data.data.items);
              } else {
                  this.membershiplist = data.data.items;
                  this.totalRecords = data.data.totalCount;
              }
          },
          err => {
              this.errorMessage = err.error.message;
          }
      );
  }

  searchWithDateFilter() {
      this.loadMemberships(this.lastTableLazyLoadEvent);
  }


    clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'planName', 'contains');
    this.dt.filter('', 'price', 'contains');
    this.dt.filter('', 'duration', 'contains');
    this.dt.filter('', 'status', 'contains');
    this.dt.filter('', 'createdby', 'contains');
    this.dt.filter('', 'updatedby', 'contains');
    this.dt.filter('', 'discountPrice', 'contains'); 
    this.calvalue = null;
    this.ucalvalue = null;
    this.dcalvalue = null;
    this.scalvalue = null;
    this.status = null;
    this.pDropDownId1.clear(null);
    this.pDropDownId2.clear(null);
    this.pDropDownId3.clear(null);
    this.loadMemberships(this.lastTableLazyLoadEvent);
    }


  exportExcel() {
    this.downloadFlg = true;
    this.loadMemberships(this.lastTableLazyLoadEvent);
  }

  exportExcelSheet(membershipList) {
      var propertiesRemove = ['id','currencySymbols', 'benefit', 'status','disable'];
      this.downloadMembershipList = membershipList;
      this.downloadMembershipList.forEach(function (item) {
          if (item.status) {
              item['status'] = 'Active';
          } else {
              item['status'] = 'In-Active';
          }
          if (item.sport.length > 0) {
            item['sport'] = item['sport'][0]['name'];
          }
          propertiesRemove.forEach(function (prop) {
              delete item[prop];
          });
      });
      this.downloadMembershipList.forEach(function (item) {
          propertiesRemove.forEach(function (prop) {
              delete item[prop];
          });
      });

      import("xlsx").then(xlsx => {
          const worksheet = xlsx.utils.json_to_sheet(this.downloadMembershipList);
          const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
          const excelBuffer: any = xlsx.write(workbook, {
              bookType: "xlsx",
              type: "array"
          });
          this.saveAsExcelFile(excelBuffer, "Membership_List");
      });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
      import("file-saver").then(FileSaver => {
          let EXCEL_TYPE =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          let EXCEL_EXTENSION = ".xlsx";
          const data: Blob = new Blob([buffer], {
              type: EXCEL_TYPE
          });
          let filename;
          filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
           saveAs(data, filename);
      });
  }

  deleteMembership(membership) {
    this.confirmationService.confirm({
          message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to delete this record ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 
      // message: 'Are you sure you want to delete ' + (this.titlecasePipe.transform(membership.planName)) + '?',
      // header: 'Confirm',
      // icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var disableStatus;
        if (membership.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        var membershipData = '{"disable":' + disableStatus + '}';
        this.membershipService.updateMembership(membershipData,membership.id,).pipe(takeUntil(this.destroy$)).subscribe(res => {
          this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Membership Deleted Successfully', life: 6000 });
          setTimeout(() => {
            this.loadMemberships(this.lastTableLazyLoadEvent);
          }, 2000);
        },
        ((err) => {
          this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.message, life: 6000 });
        }));
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }

  changeStatus(membership) {
    this.confirmationService.confirm({
          message: `
      <h4 style="margin:0;">Are you sure?</h4>
      <p style="margin-top:10px;">
        You want to change this status ?
      </p>
    `,
      // message: 'Are you sure you want to delete this image ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Confirm',
    rejectLabel: 'Cancel',
      // ❌ Remove icons
    acceptIcon: '',
    rejectIcon: '' , 

      // message: 'Are you sure you want to change the status of  ' + (this.titlecasePipe.transform(membership.planName)) + '?',
      // header: 'Confirm',
      // icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var disableStatus;
        if (membership.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        var membershipData = '{"status":' + membership.status + '}';
        this.membershipService.updateMembership(membershipData, membership.id).pipe(takeUntil(this.destroy$)).subscribe(
          res => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Membership Status Updated', life: 3000 });
            setTimeout(() => {
              this.loadMemberships(this.lastTableLazyLoadEvent);
            }, 1000);
          },
          err => {
            membership.status = !membership.status;
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        membership.status = !membership.status;
      }
    });

  }
    addColumns() {
        this.hide = false;

    }

    /**
    * Use to remove more columns in the table.
    */
    removeColumns() {
        this.hide = true;
    }

    ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}

